import styled from 'styled-components';

export const TableHeaderContractCellGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: start;
	width: 100%;
`;
